import { useSearchParams } from "react-router-dom";
import { TaskFilterType } from "./TaskFilterChips";
import { useCallback } from "react";

export const TASK_FILTER_QUERY_PARAM = "task-filter";

interface UseTaskFilterChipsResult {
  /** The currently active task filter */
  activeFilter: TaskFilterType | null;
  /** When a filter is clicked, this function will be called to update the search params and the active filter */
  handleFilterClick: (filter: TaskFilterType) => void;
}

/**
 * A hook that manages the active task filter and provides a function to handle filter clicks.
 */
export const useTaskFilterChips = (): UseTaskFilterChipsResult => {
  const [searchParams, setSearchParams] = useSearchParams();

  const activeFilter = searchParams.get(
    TASK_FILTER_QUERY_PARAM
  ) as TaskFilterType | null;

  const handleFilterClick = useCallback(
    (filter: TaskFilterType) => {
      const newParams = new URLSearchParams(searchParams);
      newParams.set(TASK_FILTER_QUERY_PARAM, filter.toString());
      setSearchParams(newParams);
    },
    [searchParams, setSearchParams]
  );

  return {
    activeFilter,
    handleFilterClick,
  };
};
